import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=771e1b26&scoped=true&"
import script from "./UserHeader.vue?vue&type=script&lang=js&"
export * from "./UserHeader.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/member.css?vue&type=style&index=0&id=771e1b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e1b26",
  null
  
)

export default component.exports